export default __webpack_public_path__ + "2b4b9f5c724fb81b764e1d7a2e40c1dd.png";